var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-nav"},[_c('router-link',{staticClass:"nav",attrs:{"to":{name: 'Home'}}},[_vm._v("电费计算")]),_c('router-link',{staticClass:"nav",attrs:{"to":{name: 'record'}}},[_vm._v("历史记录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }